import React from 'react'
import { observer, inject } from 'mobx-react'
import SelectWithLoader from '../../../common/SelectWithLoader'

const DataTypeSelect = ({ uiStore, selectionStore, rightSidebarStore }) => {
  return (
    <SelectWithLoader
      isCompact
      value={uiStore.dataTypeSelect.find((option) => option.value === rightSidebarStore.aggSelector)}
      options={uiStore.dataTypeSelect}
      defaultValue={{ value: 'sum', label: 'Aggregate' }}
      onChange={(selectedOption) => {
        rightSidebarStore.setAggSelector(selectedOption.value)
        if (selectedOption.value === 'dissolved') {
          // will handle data loading here
          // load analysis
          return
        }
        if (selectedOption.value === 'sum') {
          // handle the age sex distribution chart when switching to sum here
          // const targetGroup = selectionStore.data && selectionStore.data.group
          // if (targetGroup && targetGroup.pk) {
          //   targetGroup.analysis = new RegionAnalysis()
          //   targetGroup.analysis.load([pop], geojson)
          // }
        }
      }}
      isDisabled={rightSidebarStore.singlePolygonData || (rightSidebarStore.polygonData.length === 0 && !rightSidebarStore.populationData)}
    />
  )
}

export default inject('uiStore', 'selectionStore', 'rightSidebarStore')(observer(DataTypeSelect))
